// import './App.css'
import './css/commons.css'
import './css/custom.css'
import './css/reset.css'


import React, {Component} from 'react';
import {
	executeSparql,
	inverseQuery,
	renderResourceDescription,
	renderResourceMainCaption, renderResourceType, renderTokenContext, renderTokenReference,
} from "./utils/Functions.jsx";
import Property from "./components/Property";
import PropertyAutoload from "./components/PropertyAutoload";

import {v4 as uuidv4} from "uuid";

const particlesJS = require('particles.js')

// const particlesJS = require('particles.js')

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			mainJson: null,
			iri: "",
			title: "",
			type: "",
			properties: {},
			descriptionProp: "",
			descriptionValue: "",
			inverseProperties: [],
			directProperties: [],
			tokenContext: [],
			tokenReference: []
		}
	}

	componentDidMount() {

		// eslint-disable-next-line no-restricted-globals
		// console.log(location.href)
		// eslint-disable-next-line no-restricted-globals
		// let queryString2 = location.href.split("?")[1].replace(/^\//, '');

		// eslint-disable-next-line no-restricted-globals

		let queryString2 = ""
		// eslint-disable-next-line no-restricted-globals
		queryString2 = "http://" + location.href.split("://")[location.href.split("://").length - 1]
		//  queryString2 = location.href.replaceAll("https://lila-erc.eu","http://lila-erc.eu");
		// window.history.pushState('page2', 'Title', queryString2);


		// da mettere a posto
		// eslint-disable-next-line no-restricted-globals
		// if (location.protocol === 'https:') {
		// 	// console.log("https")
		// 	window.history.replaceState({
		// 		path: queryString2.replace("http", "https")
		// 	}, "", queryString2.replace("http", "https"));
		// } else {
		// 	// console.log("http")
		// 	// window.history.replaceState({
		// 	// 	path: queryString2.replace("https", "http")
		// 	// }, "", queryString2.replace("https", "http"));
		// }

		executeSparql(queryString2, (results) => {
			//console.log(results);
			this.setState({iri: queryString2});

			let tmpDirectsProp = []
			results.results.bindings.forEach(result => {
				tmpDirectsProp.push(<PropertyAutoload key={uuidv4()} propertyIRI={result.p.value} subject={queryString2}
				                                      count={parseInt(result.o.value)} direct={true}/>)
			})

			this.setState({directProperties: tmpDirectsProp})

			// let toBerenderProps = {}
			//
			// results.results.bindings.forEach(result => {
			// 	if (result.p.value === "http://www.w3.org/2000/01/rdf-schema#label") {
			// 		this.setState({title: result.o.value})
			// 	}
			// 	if (result.p.value === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type") {
			// 		this.setState({type: result.o.value})
			// 	}
			//
			// 	if (result.p.value in toBerenderProps) {
			// 		toBerenderProps[result.p.value].push(result)
			// 	} else {
			// 		toBerenderProps[result.p.value] = []
			// 		toBerenderProps[result.p.value].push(result)
			// 	}
			// 	//
			// 	//
			//
			// })

			// add direct relation properties
			// Object.entries(toBerenderProps).forEach(([key, value]) => {
			// 	let propstemp = this.state.properties
			// 	propstemp[key] = <Property ref={React.createRef()} pJson={value}/>
			// 	this.setState({properties: propstemp})
			//
			// })

			//render description
			renderResourceDescription(queryString2).then(r => {
				this.setState({descriptionProp: r[0], descriptionValue: r[1]})
				// console.log(r)
			})

			renderResourceMainCaption(queryString2).then(r => {
				let me = this
				this.setState({title: r[1]})
				// console.log(r)
			})

			renderResourceType(queryString2).then(r => {
				r.forEach(rItem => {
					//this is a LiLa puculiar feature : check if terminal
					if (rItem.props.rdfType.includes("powla") && rItem.props.rdfType.includes("Terminal")) {

						renderTokenContext(queryString2).then(r => {
							this.setState({tokenContext: r})
						})


						renderTokenReference(queryString2).then(r => {
							this.setState({tokenReference: r})
						})


					}

				})
				this.setState({type: r})
			})


			//this.setState({mainJson: JSON.stringify(results), iri: queryString2})


		})

		inverseQuery(queryString2, (r) => {
			let tmpInverseProp = []
			r.results.bindings.forEach(result => {
				// console.log(result)
				tmpInverseProp.push(<PropertyAutoload key={uuidv4()} propertyIRI={result.p.value} subject={queryString2}
				                                      count={parseInt(result.o.value)} direct={false}/>)
				// console.log(result)
			})

			this.setState({inverseProperties: tmpInverseProp})
		})
	}


	render() {
		return (<>
			<title>{"LiLaView - " + this.state.title}</title>
			<article>
				<header>
					<hgroup>
						<h1>
							<span>{this.state.title}</span>
						</h1>
						<h2>
							<a className="iri"
							   href={this.state.iri}>{this.state.iri}</a>
							<span className="istance"
							      style={{float: "right", textAlign: "right", display: "inline-block"}}>
								{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
								<a target="_blank" rel="noreferrer">
				                    <span className="istanceOf">Entity type:</span>
				                </a>
								{this.state.type}
				            </span>
							<div id="seeOnLodlive" className="sp">
								<a title="view resource on lodlive" target="_blank"
								   href={"https://lila-erc.eu/lodlive/app_en.html?" + this.state.iri}
								   rel="noreferrer"></a>
							</div>
						</h2>
					</hgroup>

					<div id="abstract" className={this.state.descriptionProp === undefined ? "empty" : ""}>

						{this.state.descriptionProp}
						{this.state.descriptionValue}

					</div>
					<div id={"lilaTokens"} className={this.state.tokenContext.length > 0 ? "" : "empty"}>
						{this.state.tokenContext.length > 0 ?
							<><p style={{"fontWeight": "400"}}>Token context:</p>
								{this.state.tokenContext.map(property => {
									return property
								})}</> : ""}
						{this.state.tokenReference.length > 0 ?
							<><br/><p style={{"fontWeight": "400","marginTop":"8px"}}>Token reference:</p>
								{this.state.tokenReference.map(property => {
									return property
								}).reduce((prev, curr) => [prev, '; ', curr])}
							</> : ""}


					</div>
				</header>
				<aside className={"empty"}></aside>
				<div id={"directs"}>

					<table>
						<tbody>


						{this.state.directProperties.map(property => {
							return property
						})}
						</tbody>
					</table>

				</div>
				<div id="inverses" className=""><h3>Inverse relations</h3>
					<table>
						<tbody>
						{this.state.inverseProperties.map(property => {
							return property
						})}
						{/*{this.state.mainJson !== null ? this.state.mainJson : ""}*/}
						</tbody>
					</table>
				</div>
				<div id="lodCloud" className="empty"></div>
			</article>
			<footer>
				<div id="download">
					<span id="linkBack"></span>
					{/*<a href="https://github.com/dvcama/LodView" id="linkGit" target="_blank"*/}
					{/*   title="based on LodView v1.2.1-SNAPSHOT">scarica lodview per pubblicare i tuoi dati</a>*/}
				</div>
				<div id="endpoint">
					<ul>
						<li>data from: <a href="https://lila-erc.eu/sparql/">https://lila-erc.eu/sparql/</a></li>
						<li><a target="_blank" href={"https://lila-erc.eu/lodlive/app_en.html?" + this.state.iri}
						       rel="noreferrer">View
							on LodLive</a></li>
					</ul>
				</div>
			</footer>
		</>);
	}
}

export default App;





